import categoryService from '@/services/categoryService';

export default {
  namespaced: true,
  state: {
    darkMode: localStorage.getItem('darkMode') === 'true' || false,
    drawer: false,
    activeTab: 'standard',
    categories: [],
    navCategories: [],
    allCategories: [],
    loading: false,
    error: null
  },
  getters: {
    darkMode: state => state.darkMode,
    drawer: state => state.drawer,
    activeTab: state => state.activeTab,
    categories: state => state.categories,
    navCategories: state => state.navCategories,
    allCategories: state => state.allCategories,
    loading: state => state.loading,
    error: state => state.error,
    getCurrentTheme: state => state.darkMode ? 'darkTheme' : 'lightTheme',
    getCategoryColor: state => categoryId => {
      // Chercher d'abord dans les catégories dynamiques
      const category = state.allCategories.find(cat => cat._id === categoryId || cat.slug === categoryId);
      if (category && category.color) {
        return category.color;
      }
      
      // Couleurs par défaut pour les catégories principales
      const colors = {
        politique: 'error',
        economie: 'success',
        sport: 'warning',
        international: 'info',
        technologie: 'purple',
        sante: 'pink',
        culture: 'orange',
        autres: 'grey'
      }
      return colors[categoryId] || 'primary'
    }
  },
  mutations: {
    TOGGLE_DARK_MODE(state) {
      state.darkMode = !state.darkMode
      localStorage.setItem('darkMode', state.darkMode)
    },
    SET_DARK_MODE(state, value) {
      state.darkMode = value
      localStorage.setItem('darkMode', value)
    },
    TOGGLE_DRAWER(state) {
      state.drawer = !state.drawer
    },
    SET_DRAWER(state, value) {
      state.drawer = value
    },
    SET_ACTIVE_TAB(state, tab) {
      state.activeTab = tab
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_ALL_CATEGORIES(state, categories) {
      state.allCategories = categories
    },
    SET_NAV_CATEGORIES(state, categories) {
      state.navCategories = categories
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories
    },
    SET_PREFERRED_CATEGORIES(state, categories) {
      // Stockage des préférences utilisateur
      state.preferredCategories = categories
    },
    SET_FOLLOWED_SOURCES(state, sources) {
      // Stockage des sources suivies
      state.followedSources = sources
    },
    SET_READING_HISTORY(state, history) {
      // Stockage de l'historique de lecture
      state.readingHistory = history
    }
  },
  actions: {
    toggleDarkMode({ commit }) {
      commit('TOGGLE_DARK_MODE')
    },
    setDarkMode({ commit }, value) {
      commit('SET_DARK_MODE', value)
    },
    toggleDrawer({ commit }) {
      commit('TOGGLE_DRAWER')
    },
    setDrawer({ commit }, value) {
      commit('SET_DRAWER', value)
    },
    setActiveTab({ commit }, tab) {
      commit('SET_ACTIVE_TAB', tab)
    },
    // Actions pour les catégories
    async fetchAllCategories({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        
        const categories = await categoryService.getCategories()
        commit('SET_ALL_CATEGORIES', categories)
        return categories
      } catch (error) {
        commit('SET_ERROR', 'Erreur lors de la récupération des catégories')
        console.error('Erreur lors de la récupération des catégories:', error)
        return []
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchNavCategories({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        
        const categories = await categoryService.getCategories({ showInNav: true })
        commit('SET_NAV_CATEGORIES', categories)
        return categories
      } catch (error) {
        commit('SET_ERROR', 'Erreur lors de la récupération des catégories de navigation')
        console.error('Erreur lors de la récupération des catégories de navigation:', error)
        return []
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchCategories({ dispatch }) {
      // Récupérer à la fois toutes les catégories et celles pour la navigation
      await Promise.all([
        dispatch('fetchAllCategories'),
        dispatch('fetchNavCategories')
      ])
    }
  }
}